import { forwardRef } from "react";
import { IconSize } from "../../classes/enums/ButtonEnum";
import { ToolShape } from "../../classes/enums/ToolsEnum";
import { getIconSizeClass } from "../../classes/utils/UiUtils";
import { iconMapping } from "../../config/iconConfig";
import Tooltip, { TooltipOrientation } from "../tooltip/Tooltip";
import "./ToggleButton.css";

const ToggleButton = forwardRef(
  (
    {
      icon,
      iconSize = IconSize.LARGE,
      text = null,
      isSmall = false,
      shape = ToolShape.CIRCLE,
      tooltipOrientation = TooltipOrientation.Left,
      isSelected = false,
      noBgColor = false,
      disabled = false,
      onClick = () => {},
      className = "",
      ...props
    },
    ref
  ) => {
    const IconComponent = iconMapping[icon];

    const renderMainElement = () => {
      if (IconComponent) {
        return (
          <div className="App-toggle-button-icon">
            {IconComponent && (
              <div
                className={`App-toggle-button-icon-container ${getIconSizeClass(
                  iconSize
                )} ${isSelected ? "selected" : ""}`}
              >
                {text ? (
                  <Tooltip text={text} orientation={tooltipOrientation}>
                    <IconComponent />
                  </Tooltip>
                ) : (
                  <IconComponent />
                )}
              </div>
            )}
          </div>
        );
      }

      return null;
    };

    return (
      <div
        ref={ref}
        onClick={disabled ? undefined : onClick}
        className={`App-toggle-button 
        ${
          shape === ToolShape.CIRCLE
            ? "App-toggle-button-circle"
            : "App-toggle-button-square"
        }
        ${isSmall ? "App-toggle-button-small" : ""}
        ${isSelected ? "App-toggle-button-selected" : ""}
        ${noBgColor ? "App-toggle-button-no-bg" : ""}
        ${disabled ? "disabled" : ""}
        ${className}`}
        {...props}
      >
        {renderMainElement()}
      </div>
    );
  }
);

ToggleButton.displayName = "ToggleButton";

export default ToggleButton;
